<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="close()"
>
  @if (view$ | async; as view) {
    <div class="alerts-panel" role="dialog" aria-label="Notifications">
      <h3 class="alerts-header">Notifications</h3>

      <div class="alerts-tabs" role="tablist">
        <span class="alerts-tab-indicator" [class.right]="view.tab === 'unread'" aria-hidden="true">
        </span>

        <button
          type="button"
          role="tab"
          class="alerts-tab"
          [class.active]="view.tab === 'all'"
          [attr.aria-selected]="view.tab === 'all'"
          (click)="selectTab('all')"
        >
          All
        </button>

        <button
          type="button"
          role="tab"
          class="alerts-tab"
          [class.active]="view.tab === 'unread'"
          [attr.aria-selected]="view.tab === 'unread'"
          (click)="selectTab('unread')"
        >
          Unread
          @let unread = (unreadCount$ | async) ?? 0;
          @if (unread > 0) {
            <span class="alerts-tab-count">{{ unread > 9 ? '9+' : unread }}</span>
          }
        </button>
      </div>

      <div class="alerts-scroll">
        <!-- Persistent alerts sit above the feed and outside the tab filter. -->
        @if (view.persistent.length) {
          <div class="alerts-pinned">
            <span class="alerts-section-label">Needs your attention</span>

            @for (alert of view.persistent; track alert.id) {
              <a class="alert-item pinned" [routerLink]="alert.route" (click)="close()">
                <span class="alert-icon pinned">
                  <mat-icon aria-hidden="true">{{ alert.icon }}</mat-icon>
                </span>
                <span class="alert-item-text">
                  <span class="alert-item-title">{{ alert.title }}</span>
                  <span class="alert-item-message">{{ alert.message }}</span>
                </span>
              </a>
            }
          </div>
        }

        @if (view.items.length) {
          @for (alert of view.items; track alert.id) {
            <a
              class="alert-item"
              [class.unread]="!alert.read"
              [routerLink]="alert.route"
              (click)="onSelect(alert)"
            >
              <span class="alert-icon">
                <mat-icon aria-hidden="true">{{ alert.icon }}</mat-icon>
              </span>

              <span class="alert-item-text">
                <span class="alert-item-title">{{ alert.title }}</span>
                <span class="alert-item-message">{{ alert.message }}</span>
                <span class="alert-item-time">{{ age(alert.createdAt) }}</span>
              </span>

              @if (!alert.read) {
                <span class="alert-unread-dot" aria-label="Unread"></span>
              }

              <button
                type="button"
                class="alert-dismiss"
                (click)="onDismiss($event, alert)"
                [attr.aria-label]="'Dismiss ' + alert.title"
              >
                <mat-icon aria-hidden="true">close</mat-icon>
              </button>
            </a>
          }
        } @else if (!view.persistent.length) {
          <div class="alert-empty">
            <mat-icon aria-hidden="true">notifications_none</mat-icon>
            <span>{{ view.emptyMessage }}</span>
          </div>
        }

        <!-- Only on All: the Unread tab filters what's loaded, so paging into
             older read notifications wouldn't add anything to it. -->
        @if (view.tab === 'all' && (hasMore$ | async)) {
          <button type="button" class="alerts-load-more" (click)="loadMore()">Load older</button>
        }
      </div>

      <div class="alerts-footer">
        <button
          type="button"
          class="alerts-mark-all"
          (click)="markAllRead()"
          [disabled]="((unreadCount$ | async) ?? 0) === 0"
        >
          <mat-icon aria-hidden="true">done_all</mat-icon>
          Mark all as read
        </button>
        <button
          type="button"
          class="alerts-clear-all"
          (click)="clearAll()"
          [disabled]="!(hasDismissible$ | async)"
        >
          <mat-icon aria-hidden="true">clear_all</mat-icon>
          Clear all
        </button>
      </div>
    </div>
  }
</ng-template>
